import type { DetailTab } from "../DetailDrawer";
import { CoolingRegimesTabEditable } from "./CoolingRegimesTabEditable";

export function getProductGroupDetailTabs({
  productGroupCode,
}: {
  productGroupCode: string;
}): DetailTab[] {
  return [
    {
      label: "Koelregimes",
      content: <CoolingRegimesTabEditable productGroupCode={productGroupCode} />,
    },
  ];
}
